var site = site || {};

site.dataFilter = {
	transitionSpeed: 400,
	init: function (filterSelector, itemsSelector, mobileFilter) {
		var $filter = $(filterSelector),
			$items = $(itemsSelector),
			$mobileFilter = mobileFilter !== undefined ? $(mobileFilter) : null;

		$($filter).on('click', 'a, button', function(e) {
			e.preventDefault();

			var $this = $(this),
				filterValue = $this.data('filter'),
				$filter = $this.closest('ul');

			$items.animate({
				opacity: 0
			}, site.dataFilter.transitionSpeed);

			if (!$this.hasClass('selected')) {
				$('a, button', $filter).removeClass('selected');
				$this.addClass('selected');
			}
			else {
				$('a, button', $filter).removeClass('selected');
				filterValue = 'all';
			}

			setTimeout(function() {
				$items.animate({
					opacity: 1
				}, site.dataFilter.transitionSpeed);

				$('.item', $items).show();

				if (filterValue !== 'all') {
					$('.item:not(' + filterValue + ')', $items).hide();
				}

			}, site.dataFilter.transitionSpeed);
		});

		if ($mobileFilter) {
			$mobileFilter.on('change', function () {
				var val = $(this).find("option:selected").val();
				$('[data-filter*=' + val + ']', $filter).trigger('click');
			});
		}

		var hash = location.hash.slice(1);
		var selectedHash = hash.length > 0 ? hash : '';
		if (hash) {
			$filter.find('.' + selectedHash).trigger('click');
		}
	}
};